export const RATE_A_SERVICE = `project/ratings/rate`; //#DONE
export const ALL_RATINGS_FOR_A_SERVICE = {
  SERVICE_ID: (serviceId) => `project/ratings/${serviceId}`,
}; ///????
export const ALL_RATINGS_FOR_A_USER = {
  USER_ID: (userId) => `project/ratings/user-ratings/${userId}`,
};